// extracted by mini-css-extract-plugin
module.exports = {"step":"ReferFriendStep_step__i1lZH","content":"ReferFriendStep_content__E7oWF","stepNumber":"ReferFriendStep_stepNumber__jKg6Q","description":"ReferFriendStep_description__X02ES"};